import { ILevelInfo } from "./../../../../interfaces/levelInfo";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Component, OnInit, Inject } from "@angular/core";
import { TranslateService } from "@ngstack/translate";
import { LevelInfoService } from "src/app/services/http/business/levelInfo/level-info.service";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { SoundEnum } from "src/app/enums/sound.enum";
import { ErrorsService } from "src/app/services/common/errors.service";
import { IError } from "src/app/interfaces/error.interface";

@Component({
  selector: "app-level-info-entry",
  templateUrl: "./level-info-entry.component.html",
  styleUrls: ["./level-info-entry.component.css"]
})
export class LevelInfoEntryComponent implements OnInit {
  form: FormGroup;
  param: any;
  errorList: IError[] = [];
  errObject: any;
  errors = new Array();
  constructor(
    private fb: FormBuilder,
    private snackBar: SnackBarService,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private levelInfoService: LevelInfoService,
    private dialogRef: MatDialogRef<LevelInfoEntryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      PackageId: [
        this.data.PackageId,
        Validators.compose([Validators.required])
      ],
      Name: [
        this.data && this.data.Name ? this.data.Name : null,
        Validators.compose([Validators.required, Validators.maxLength(50)])
      ],
      Code: [
        this.data && this.data.Code ? this.data.Code : null,
        Validators.compose([Validators.required, Validators.maxLength(20)])
      ],
      IsActive: [
        this.data && this.data.IsActive ? this.data.IsActive : false,
        Validators.compose([Validators.required])
      ],
      ExpireDay: [
        this.data && this.data.ExpireDay ? this.data.ExpireDay : null,
        Validators.compose([
          Validators.required,
          Validators.min(1),
          Validators.max(365)
        ])
      ],
      MaxCapacity: [
        this.data && this.data.MaxCapacity ? this.data.MaxCapacity : null,
        Validators.compose([
          Validators.required,
          Validators.min(1),
          Validators.max(600)
        ])
      ],
      IsGraduatedLevel: [
        this.data && this.data.IsGraduatedLevel
          ? this.data.IsGraduatedLevel
          : false,
        Validators.compose([Validators.required])
      ],
      Id: [this.data && this.data.Id ? this.data.Id : 0]
    });
  }

  submit(data: ILevelInfo) {
    data.PackageId = +data.PackageId;
    data.ExpireDay = +data.ExpireDay;
    if (this.data && !this.data.Id) {
      this.levelInfoService.add(data).subscribe(
        () => {
          //this.onClose();
          this.snackBar.OpenSnackBar(
            this.translate.get("success.registration"),
            "ok",
            5000,
            SoundEnum.beep
          );
        },
        err => {
          // this.errObject = this.errorService.getError(err);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(err);
          this.errorList = this.errorService.getErrorList(err.error);
        }
      );
    } else {
      this.levelInfoService.edit(data).subscribe(
        () => {
          //this.onClose();
          this.snackBar.OpenSnackBar(
            this.translate.get("success.registration"),
            "ok",
            5000,
            SoundEnum.beep
          );
        },
        err => {
          // this.errObject = this.errorService.getError(err);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(err);
          this.errorList = this.errorService.getErrorList(err.error);
        }
      );
    }
  }

  onClose() {
    this.dialogRef.close();
  }
}
